










import {Component, Prop, Watch} from 'vue-property-decorator';
import BaseComponent from '@/core/components/BaseComponent';
import {Client, Measurement} from "@/core/services/MedicaPro/models";
import {Api} from "@/core/services/MedicaPro/Api";
import ClientMeasurementListRow
    from "@/components/Admin/Clients/Details/Components/ClientDashboard/Components/ClientMeasurementList-Row.vue";
import bus from "@/main";

@Component({
    components: {
        ClientMeasurementListRow

    }
})
export default class ClientMeasurementList extends BaseComponent {

    // Bindings to parent
    @Prop() client!: Client;
    @Prop({default: 8}) minScore!: number;
    @Prop({default: 20}) maxScore!: number;

    // Bindings to view
    public isReady = false;
    public items: Measurement[] = [];

    public mounted() {
        this.renderView();

        bus.$on('measurementSaved', this.loadData);
    }

    public beforeDestroy() {
        super.beforeDestroy();
    }

    private renderView() {
        this.isReady = true;
        this.loadData();
    }

    private loadData() {
        Api.measurements().get()
            .where('client_id', this.client.id!)
            .orderDesc('date')
            .find(measurements => {
                const usedTypes: string[] = [];
                this.items = measurements

                    // Filter by latest score
                    .filter(measurement => {
                        if (usedTypes.includes(measurement.measurement_type_identifier!)) {
                            return false;
                        } else {
                            usedTypes.push(measurement.measurement_type_identifier!);
                            return true;
                        }
                    })

                    // Filter by score range
                    .filter(measurement => measurement.smartValue >= this.minScore && measurement.smartValue <= this.maxScore);
            });
    }

}
